import { Button, Card, Image, Paper, SimpleGrid, Text } from "@mantine/core";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Eye } from "tabler-icons-react";
import { userTypes } from "../../AdminPages/Users/userTypes";
import jobSeeker from "../../assets/jobSeeker.png";

const JobSeekersFollowingMe = ({
  followers,
  setLoading,
  refresh,
  setRefresh,
}) => {
  const navigate = useNavigate();
  const card = followers?.map((data, index) => {
    if (data.role === userTypes["Job Seekers"]) {
      return (
        <Card
          key={index}
          radius={"md"}
          sx={{
            border: "1px solid #E32339",
            borderRadius: "0.5rem",
            ":hover": {
              boxShadow: "0 5px 12px #0003",

              // transform: "scale(1.005)",
            },
            boxShadow: "0 2px 8px #00000026",
            transition: "box-shadow .2s",
            transitionDuration: "0.2s",
            transitionTimingFunction: "ease",
            transitionDelay: "0s",
            transitionProperty: "box-shadow",
          }}
          style={{ width: "302px" }}
        >
          <Card.Section
            style={{ height: "201px", position: "relative" }}
            withBorder
          >
            <Image
              withPlaceholder
              height={"201px"}
              width={"100%"}
              fit={"cover"}
              src={data?.jobSeeker?.[0]?.jobSeekerProfileImage || jobSeeker}
            />

            <div
              style={{ position: "absolute", bottom: 0, right: 0, margin: 8 }}
            >
              <Button
                sx={{
                  ":hover": {
                    color: "#fff",
                  },
                }}
                variant="filled"
                color={"red.9"}
                component={Link}
                rightIcon={<Eye />}
                to={`/jobseeker/profile/${data._id}`}
                uppercase
              >
                View
              </Button>
            </div>
          </Card.Section>
          <Card.Section>
            <Paper p={"md"}>
              <Text lineClamp={1} weight={500} size={"lg"}>
                {data?.firstName} {data?.lastName}
              </Text>
              <Text lineClamp={1} weight={500} size={"lg"}>
                {data?.jobSeeker?.[0]?.jobTitle}
              </Text>

              <Text>{data?.jobSeeker?.[0]?.summary}</Text>
            </Paper>
          </Card.Section>
        </Card>
      );
    } else if (data.role === userTypes.Companies) {
      console.log("Its a company");
    }
  });

  return (
    <SimpleGrid
      cols={5}
      spacing="md"
      breakpoints={[
        { maxWidth: 1750, cols: 3, spacing: "md" },
        { maxWidth: "xl", cols: 3, spacing: "md" },
        { maxWidth: "lg", cols: 2, spacing: "md" },
        { maxWidth: "md", cols: 2, spacing: "md" },
        { maxWidth: "sm", cols: 1, spacing: "sm" },
        { maxWidth: "xs", cols: 1, spacing: "sm" },
      ]}
    >
      {card}
    </SimpleGrid>
  );
};

export default JobSeekersFollowingMe;
